import React, {Component} from 'react';

import { Form, Row, Button, message} from 'antd';

import components from './../components';

import service from './../services';

class Dingding extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
             // 你们申请的appid
             APPID: 'dingoaqoj9jhjbfmoax7nv',
                // APPID: 'dingnjp8vfyzenam5eat',
             // 跳转当前页面
             REDIRECT_URI: encodeURIComponent('http://jxzl.hcvt.cn/education-jxcp-service-web/sso/hcvtlogin')
            // REDIRECT_URI: encodeURIComponent(' http://jxzl.hcvt.cn/education-jxcp-service-supv/sso/hcvtlogin')
            // REDIRECT_URI: encodeURIComponent('http://sgpt.hcvt.cn/education-jxcp-service-web/sso/hcvtlogin')
        }
    }

    componentDidMount() {
        const appId = this.state.APPID
        const redirectUrl = this.state.REDIRECT_URI
        let URL=encodeURIComponent(`https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appId}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${redirectUrl}`)
        // 实例化对象
        var obj =window.DDLogin({
            id:"login_container",
            goto: URL,
            style: "border:none;background-color:#FFFFFF;",
            width : "100%",
            height: "400"
        });
        // 监听消息处理方法
        const handleMessage = (event) => {
            // 获取loginTempCode
            const loginTempCode = event.data;
            // 获取消息来源
            const origin = event.origin;
            // 拼接 url
            const url = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appId}&response_type=code&scope=snsapi_login&state=dinglogin&redirect_uri=${redirectUrl}&loginTmpCode=${loginTempCode}`
            // 如果来源为https://login.dingtalk.com，则在当前窗口打开回调链接
            if (origin === 'https://login.dingtalk.com') {
                window.open(encodeURI(url), '_parent')
            }
        };
        // 监听iframe的消息
        if (typeof window.addEventListener != 'undefined') {
            window.addEventListener('message', handleMessage, false);
        } else if (typeof window.attachEvent != 'undefined') {
            window.attachEvent('onmessage', handleMessage);
        }
       
		//params为地址栏路由后面的参数（我这里是从 父组件中传过来的）
		//手机钉钉扫码后 确认登录 成功后 网页地址栏会出现一个参数：state='dinglogin'
		//同时出现参数code （因为我们需要拿到这个参数 传给后台来获取用户信息）判断后再进行下一步操作
    }



    onChange() {
        const imageUrl = service.account.getKaphcha();
        this.setState({
            imageUrl
        });
    }

    onSubmit(event) {
        event.preventDefault();
        this.props.form.validateFields((error, values) => {
            if(!error) {
                this.setState({
                    loading: true
                });
                service.account.login(values).then(payload => {
                    this.setState({
                        loading: false
                    });
                    window.location.hash = '/';
                    
                    if(payload) {
                      this.props.updateAccount(payload);
                    }
                    this.onChange();
                }).catch(error => {
                    message.error(error.message);
                });
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
              
            <div id='login_container'></div>
                               
        );
    }
}

export default Form.create()(Dingding);